import { render, staticRenderFns } from "./deployNew.vue?vue&type=template&id=baef27ee&scoped=true&"
import script from "./deployNew.vue?vue&type=script&lang=js&"
export * from "./deployNew.vue?vue&type=script&lang=js&"
import style0 from "./deployNew.vue?vue&type=style&index=0&id=baef27ee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "baef27ee",
  null
  
)

export default component.exports